export default __webpack_public_path__ + "static/media/bg.f0721720.png";